import { transparentize, mode } from '@chakra-ui/theme-tools';
const getSize = (value) => {
    return {
        dialog: {
            maxWidth: value,
        },
    };
};
const getFullScreenStyle = () => {
    return {
        dialog: {
            borderRadius: 'none',
            margin: 0,
            maxWidth: 'none',
            height: '100%',
        },
    };
};
const getFitContentStyle = () => {
    return {
        dialog: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
    };
};
const getBaseStyle = (props) => ({
    overlay: {
        bg: transparentize('gray.600', 0.6)(props.theme),
        display: 'flex',
        justifyContent: 'center',
    },
    dialog: {
        borderRadius: 'base',
        bg: mode('white', 'gray.550')(props),
        color: 'inherit',
        boxShadow: 'lg',
        marginY: '3rem',
    },
    header: {
        paddingX: 6,
        paddingY: 5,
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        fontWeight: 'semibold',
    },
    body: {
        paddingX: 6,
        paddingY: 0,
        overflow: 'auto',
        flex: '1 1 0%',
    },
    footer: {
        paddingX: 6,
        paddingY: 5,
    },
    closeButton: {
        position: 'absolute',
        top: 4,
        right: 6,
        insetEnd: 3,
    },
});
const parts = ['overlay', 'dialog', 'header', 'body', 'footer', 'closeButton'];
const defaultProps = {
    size: 'md',
};
const sizes = {
    sm: getSize('400px'),
    md: getSize('480px'),
    lg: getSize('640px'),
    xl: getSize('860px'),
    full: getSize('full'),
};
export default {
    parts,
    defaultProps,
    sizes,
    baseStyle: getBaseStyle,
    variants: {
        fullScreen: getFullScreenStyle,
        fitContent: getFitContentStyle,
    },
};
//# sourceMappingURL=modal.js.map